import React from "react";
import { Tree, Panel, Label, TextBox} from "lib/components";
import { getLogger } from "lib/util";
import { useState } from "react";
import { AuthType } from "lib/util/AuthType";

const log = getLogger("designer.ModelEditor");

export function ModelEditor() {
  const [modelName, setModelName] = useState()
  return (
    <Panel modelName="meh" fillRow fillHeight>
      <Label caption="Query Model Editor" look="default4" />
      <TextBox caption="Model" field="model" lookupModel="query-model-list" width={400} onChange={(value) => setModelName("query-model?search=" + value)}/>
      <Panel modelName={modelName} autoSearch fillRow fillHeight >
        <Tree data={getTreeData} fillRow fillHeight />
      </Panel>
    </Panel>
  );
}

function getTreeData(context) {
  let data = context.getActiveData();
  if (data != null) {
    let def = data.definition;
    const result = JSON.parse(def);
    log.info("Tree data %s", result);
    return result;
  }
  return null;
}

export function getPageOptions() {
  return {title: "Query Model Editor", auth: AuthType.ANY};
}
